import Navbar from "./sections/navbar";
import Hero from "./sections/hero";
import HowItWorks from "./sections/howItworks";
import ServiceAdvantage from "./sections/serviceAdvantage";
import AskedQuestions from "./sections/askedQuestions";
import TrackServiceOrder from "./sections/trackServiceOrder";
import Footer from "./sections/footer";

export default function LandingPage() {
  return (
    <>
      <Navbar />
      <Hero />
      <HowItWorks />
      <ServiceAdvantage />
      <AskedQuestions />
      <TrackServiceOrder />
      <Footer />
    </>
  );
}
